import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchServices = () => api.get("/services").then((r) => r.data);
export const fetchEvents = () => api.get("/events").then((r) => r.data);
export const fetchAvailability = (date) =>
  api.get(`/availability`, { params: { date } }).then((r) => r.data);
export const createAppointment = (payload) =>
  api.post("/appointments", payload).then((r) => r.data);
export const createEnquiry = (payload) =>
  api.post("/enquiries", payload).then((r) => r.data);
